import React, { Component } from "react";
import { Route } from "react-router-dom";
import { scAxiosAdmin, thirdparty } from "../..";
import { API_TOKEN_NAME, IMAGE_URL } from "../../constants";
//import { startUserSession } from '../../userSession';
import { ToastContainer, toast } from "react-toastify";
//import 'react-toastify/dist/ReactToastify.css';
import LeftSidebar from "../../component/admin/LeftSidebar";
import TopHeader from "../../component/admin/TopHeader";
//import Footer from '../../component/admin/Footer';
//import Moment from 'moment';
import Pagination from "react-js-pagination";
import Avatar from "../../images/avatar_circle.png";
import Modal from "./DeleteConfirmModalPopup";

const getAllAlbums = (data) => {
  return new Promise((resolve, reject) => {
    const req = scAxiosAdmin.request("/album/listalbum", {
      method: "get",
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
      },
      params: {
        ...data,
      },
    });
    req.then((res) => resolve(res.data)).catch((err) => reject(err));
  });
};

// const getSearchDoctors = (data) => {
//     return new Promise((resolve, reject) => {
//         const req = scAxiosAdmin.request('/albums/adminsearchdoctors', {
//             method: 'get',
//             headers: {
//                 'Accept': 'application/json',
//                 'Authorization': 'Bearer ' + localStorage.getItem(API_TOKEN_NAME)
//             },
//             params: {
//                 ...data
//             }
//         });
//         req.then(res => resolve(res.data))
//             .catch(err => reject(err));
//     });
// }
// const deleteDoctor = (data) => {
// 	return new Promise((resolve, reject) => {
// 		const req = scAxiosAdmin.request('/doctors/deletedoctor', {
// 			method: 'post',
// 			headers: {
// 				'Accept': 'application/json',
// 				'Authorization': 'Bearer ' + localStorage.getItem(API_TOKEN_NAME)
// 			},
// 			params: {
// 				...data
// 			}
// 		});
// 		req.then(res => resolve(res.data))
// 			.catch(err => reject(err));
// 	});
//   }
class Albums extends Component {
  state = {
    album: [],
    total: "",
    currentPage: "",
    LastPage: "",
    PerPage: "",
    FirstPageUrl: "",
    NextPageUrl: "",
    PrevPageUrl: "",
    LastPageUrl: "",
    TotalPages: "",
    activePage: 1,
    album_id: "",
    enableShdo: false,
    enableShdoLive: false,
    search_keywords: "",
  };
  handleChange = (events) => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };
  handlePageChange(pageNumber) {
    this.setState({ activePage: pageNumber });
    this.refreshAlbum(pageNumber);
  }
  // modalDeleteConfirmOpen(e, id) {
  //     this.setState({
  //         modalDeleteConfirm: true,
  //         album_id: id,
  //     });
  // }
  // modalDeleteConfirmClose() {
  //     this.setState({
  //         modalDeleteConfirm: false
  //     });
  // }
  // modalDeleteDoctor(id) {
  //     /*this.setState({
  //       selectedPost: i,
  //     });*/
  //     this.setState({
  //         modalDeleteConfirm: false
  //     });
  //     const data = {
  //         albums_id: id
  //     }
  //     deleteAlbum(data)
  //         .then(res => {
  //             if (res.status === true) {
  //                 toast.success(res.message, {
  //                     position: toast.POSITION.TOP_RIGHT
  //                 });
  //                 setTimeout(function () {
  //                     window.location.href = '/album';
  //                 }, 6000);
  //             } else {
  //                 toast.error(res.message, {
  //                     position: toast.POSITION.BOTTOM_RIGHT
  //                 });
  //             }
  //             //window.location='/departments';
  //         })
  //         .catch(err => {
  //             console.log(err);
  //         });
  // }
  refreshAlbum = (page) => {
    this.setState({ enableShdo: true });
    const data = {
      page: page,
    };
    getAllAlbums(data)
      .then((res) => {
        console.log(res.data);
        if (res.status === true) {
          var records = res.data;
          this.setState({ album: records });
          this.setState({ total: res.data.total });
          this.setState({ currentPage: res.data.current_page });
          this.setState({ PerPage: res.data.per_page });
          this.setState({ FirstPageUrl: res.data.first_page_url });
          this.setState({ NextPageUrl: res.data.next_page_url });
          this.setState({ PrevPageUrl: res.data.prev_page_url });
          this.setState({ LastPageUrl: res.data.last_page_url });
          this.setState({ LastPage: res.data.last_page });
          this.setState({
            TotalPages: Math.ceil(this.state.total / this.state.PerPage),
          });
        } else {
          this.setState({ album: "" });
        }
        this.setState({ enableShdo: false });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  // SearchAlbum = (e) => {
  //     const data = {
  //         keywords: this.state.search_keywords
  //     }
  //     getSearchAlbum(data)
  //         .then(res => {
  //             if (res.status === true) {
  //                 var records = res.data.data;
  //                 this.setState({ album: records });
  //                 this.setState({ total: res.data.total });
  //                 this.setState({ currentPage: res.data.current_page });
  //                 this.setState({ PerPage: res.data.per_page });
  //                 this.setState({ FirstPageUrl: res.data.first_page_url });
  //                 this.setState({ NextPageUrl: res.data.next_page_url });
  //                 this.setState({ PrevPageUrl: res.data.prev_page_url });
  //                 this.setState({ LastPageUrl: res.data.last_page_url });
  //                 this.setState({ LastPage: res.data.last_page });
  //                 this.setState({ TotalPages: Math.ceil(this.state.total / this.state.PerPage) });
  //             } else {
  //                 this.setState({ album: '' });
  //             }
  //         })
  //         .catch(err => {
  //             console.log(err);
  //         });
  // }

  componentDidMount() {
    this.refreshAlbum();
  }

  render() {
    //const currentPage = this.state.currentPage;
    //const previousPage = currentPage - 1;
    //const NextPage = currentPage + 1;
    //const LastPage = this.state.LastPage;
    const pageNumbers = [];
    for (let i = 1; i <= this.state.TotalPages; i++) {
      pageNumbers.push(i);
    }
    let handleDelete = async (id) => {
      let confirmation = confirm("Are you sure to delete this item?");
      if (!confirmation) {
        return;
      }
      try {
        const response = await thirdparty.delete(`/album/delete/${id}`); // Update the API endpoint

        if (response.status === 200) {
          this.refreshAlbum();
          toast.success("Data Deleted successfully!", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 3000,
          });
        }
      } catch (error) {
        console.error(`Error deleting item with ID ${id}:`, error.message);
      }
    };
    return (
      <div className="fixed-left">
        <div id="wrapper">
          <Route component={LeftSidebar} />
          <div className="content-page">
            <div className="content">
              <Route component={TopHeader} />
              <div className="row page-content-wrapper">
                <div className="col-sm-7"></div>
                <div className="col-sm-3 text-right">
                  <input
                    type="text"
                    className="form-control"
                    name="search_keywords"
                    id="search_keywords"
                    placeholder="Search"
                  />
                </div>
                <div className="col-sm-2 mb-4 text-right">
                  <a
                    href="/addAlbum"
                    className="btn btn-sm btn-primary waves-effect waves-light"
                  >
                    Add Album
                  </a>
                </div>
                <div className="col-lg-12">
                  <div className="card m-b-20">
                    <div className="card-body">
                      <section className="view-page">
                        <div className="container">
                          <div className="view-page-box">
                            <hr />
                            <div className="row">
                              {this.state.album &&
                              this.state.album.length > 0 ? (
                                this.state.album.map((album) => {
                                  return (
                                    <div className="col-lg-4" key={album.id}>
                                      <div className="news-part-event">
                                        <img
                                          src={
                                            IMAGE_URL +
                                            "/AlbumImg/" +
                                            album.album_pics
                                          }
                                          alt=""
                                          width="100%"
                                        />
                                        <div className="newdata position-relative">
                                          <div className="row">
                                            <div className="col-lg-10">
                                              <h3
                                                className="d-inline"
                                                style={{ fontSize: "18px" }}
                                                title={album.album_name}
                                              >
                                                {album.album_name
                                                  ? album.album_name
                                                  : ""}
                                              </h3>
                                            </div>
                                          </div>
                                          <h5 className="float-end position-absolute mt-2 top-0 end-0">
                                            <a href={"/editalbum/" + album.id}>
                                              <i className="fa fa-pencil-square mx-2 display-4"></i>
                                            </a>
                                            <a href={"/editalbum/" + album.id}>
                                              <i className="fa fa-eye"></i>
                                            </a>
                                            <a
                                              onClick={() =>
                                                handleDelete(album.id)
                                              }
                                            >
                                              <i className="fa fa-trash"></i>
                                            </a>
                                          </h5>
                                        </div>
                                        <p
                                          dangerouslySetInnerHTML={{
                                            __html: album.album_desc
                                              ? album.album_desc.substr(0, 170)
                                              : "",
                                          }}
                                        ></p>
                                      </div>
                                    </div>
                                  );
                                })
                              ) : (
                                <div
                                  colSpan="6"
                                  className="font_12 txt_col fontweight400 "
                                  style={{ textAlign: "center" }}
                                >
                                  {" "}
                                  There are currently no News Events.
                                </div>
                              )}
                            </div>
                            <br />
                          </div>
                        </div>
                      </section>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ToastContainer autoClose={5000} />
      </div>
    );
  }
}
export default Albums;



// WEBPACK FOOTER //
// ./src/component/admin/albums.js